import { Head } from '@inertiajs/react'
import { ReactNode } from 'react'
import logoUrl from '@/shared/assets/logo.svg'
import { cn } from '@/shared/lib/utils'
import { AuthFooter } from './AuthFooter'

interface AuthShellProps {
  children: ReactNode
  pageTitle: string
  wide?: boolean
  alignTop?: boolean
  stretch?: boolean
}

const AuthShell = ({
  children,
  pageTitle,
  wide = false,
  alignTop = false,
  stretch = false,
}: AuthShellProps) => (
  <>
    <Head title={pageTitle} />
    <div className="flex min-h-svh flex-col lg:flex-row">
      <div className="flex items-center justify-center bg-primary px-8 py-10 lg:w-[45%] lg:flex-col lg:py-16">
        <img src={logoUrl} alt="LabLogs" className="h-10 w-auto lg:h-16" />
      </div>

      <div className="flex flex-1 flex-col items-center px-6 py-10 sm:px-8 sm:py-12">
        <div
          className={cn(
            'flex w-full flex-1 flex-col',
            alignTop ? 'justify-start' : 'justify-center',
            wide ? 'max-w-2xl' : 'max-w-sm',
          )}
        >
          <div
            className={cn('text-foreground', stretch ? 'flex flex-1 flex-col gap-6' : 'space-y-6')}
          >
            {children}
          </div>
        </div>
        <AuthFooter className={cn('w-full', wide ? 'max-w-2xl' : 'max-w-sm')} />
      </div>
    </div>
  </>
)

export { AuthShell }
